export type Subscription = {
  cancel(): void;
  isInternetConnectionAvailable: boolean;
};

export const webOsExit = () => {
  try {
    window.close();
  } catch (e) {
    const message = e instanceof Error ? e.message : '' + e;
    window.elasticApm.captureError(new Error('Exit: ' + message));
  }
};
